module.exports = __webpack_public_path__ + "static/integration-38c72f5814b10e11905262d11e3b7cec.png";